import React from 'react';
import LinkBase, { type TLinkBase } from './LinkBase';

const BlockLink = (props: Omit<TLinkBase, 'kind'>) => <LinkBase {...props} kind="block" />;

export default BlockLink;
